import { useTheme } from "@/hooks/useTheme";
import logoLight from "@/assets/velloplay-logo-light.png";
import logoDark from "@/assets/velloplay-logo-dark.png";

interface ThemedLogoProps {
  className?: string;
  width?: number;
  height?: number;
  /**
   * Força uma variante específica, ignorando o tema atual.
   * Use quando o fundo do container é fixo (ex.: card sempre escuro).
   * - "light" → logo com letras brancas (para fundos escuros)
   * - "dark"  → logo com letras pretas (para fundos claros)
   */
  forceVariant?: "light" | "dark";
}

export const ThemedLogo = ({ className = "h-10", width, height, forceVariant }: ThemedLogoProps) => {
  const { theme } = useTheme();

  // theme = 'dark' | 'clean'
  // Em fundo escuro (dark) usamos o logo "light" (letras brancas).
  // Em fundo claro (clean) usamos o logo "dark" (letras pretas).
  const isDarkBg = forceVariant
    ? forceVariant === "light"
    : theme === "dark";
  const logo = isDarkBg ? logoLight : logoDark;

  return <img src={logo} alt="VelloPlay" className={className} width={width} height={height} />;
};
